import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { RegionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "./useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "./utils";

const REGIONS_QUERY = graphql(`
  query regions {
    regions {
      regions {
        id
        name
        description
        countryCode
        sortOrder
      }
    }
  }
`);

/** Every region. Static reference data, so it's fetched once per session. */
export function useRegions(
  options?: UseQueryOptions<RegionsQuery, unknown, RegionsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["regions"], REGIONS_QUERY, [{}], {
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
    ...options,
  });

  return { data: data?.regions, ...rest };
}
